module.exports = __webpack_public_path__ + "img/ger_version_history.bf3dd1ca.png";